import { commonRequest } from '@/utils/request'

const state = {
  roleDict: {},
  all: []
}

const mutations = {
  setVal: (state, obj) => {
    for (const [key, value] of Object.entries(obj)) {
      if (state.hasOwnProperty(key)) state[key] = value
    }
  }
}

const actions = {
  create: ({ commit }, data) => commonRequest({ data, url: '/role' }),
  list: ({ commit }, data) => commonRequest({ data, url: '/role/list' }),
  update: ({ commit }, data) => commonRequest({ data, url: '/role/update' }),
  remove: ({ commit }, data) => commonRequest({ data, url: '/role/remove' }),
  // all: ({ commit }, data) => commonRequest({ data, method: 'get', url: '/role' }),
  // create({ commit, state }, data) {
  //   return new Promise((resolve, reject) => {
  //     commonRequest({
  //       url: '/role',
  //       method: 'post',
  //       data
  //     }).then(res => resolve(res.data)).catch(error => reject(error))
  //   })
  // },
  // all({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     commonRequest({
  //       url: '/role',
  //       method: 'get'
  //     }).then(res => {
  //       commit("setVal", {
  //         roleDict: res.data.reduce((t, e) => (
  //           t[e.id] = e.name, t
  //         ), {})
  //       })
  //       commit("setVal", {
  //         all: res.data
  //       })
  //       resolve(res.data)
  //     }).catch(err => reject(err))
  //   })
  // },
  // update({ commit, state }, data) {
  //   return new Promise((resolve, reject) => {
  //     commonRequest({
  //       url: '/role/update',
  //       method: 'post',
  //       data
  //     }).then(res => resolve(res.data)).catch(error => reject(error))
  //   })
  // },
  // update_all({ commit, state }, data) {
  //   return new Promise((resolve, reject) => {
  //     commonRequest({
  //       url: '/role/update_all',
  //       method: 'post',
  //       data
  //     }).then(res => resolve(res.data)).catch(error => reject(error))
  //   })
  // },
  // remove({ commit, state }, data) {
  //   return new Promise((resolve, reject) => {
  //     commonRequest({
  //       url: '/role/remove',
  //       method: 'post',
  //       data
  //     }).then(res => resolve(res.data)).catch(error => reject(error))
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
